/*!
 * jQuery lightweight plugin boilerplate
 * Original author: @ajpiano
 * Further changes, comments: @addyosmani
 * Plugin functionality: @jimtierney
 * Licensed under the MIT license
 */


// the semi-colon before the function invocation is a safety 
// net against concatenated scripts and/or other plugins 
// that are not closed properly.
; (function ($, window, document, undefined) {

    // Create the defaults once
    var pluginName = 'popupPosition',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);
        this.$popup = $('#AddToGroups');
        this.popupOffset = 0;
        this.popupParent = this.$popup.parent();

        // Combine defaults and options
        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;
        this.isCalibrated = false;
        this.init();
    }

    Plugin.prototype.init = function () {
       // console.log('Run init function');
       // console.log(this.$element);
        var that = this;
        this.isCalibrated = false;
        this.calibrate();
        this.$element.on('click', function () {
            //console.log('re-click');
            that.calibrate();
        });
    };

    Plugin.prototype.calibrate = function () {
        
        //console.log('Start calibration');
        var that = this,
            $thisFocus = $(document.activeElement),
            windowScroll = $(window).scrollTop(),
            buttonX = this.$element.offset().left,
            buttonY = this.$element.offset().top - windowScroll,
            buttonWidth = this.$element.outerWidth(),
            buttonHeight = this.$element.outerHeight(),
            popupWidth = this.$popup.width(),
            popupHeight = this.$popup.height(),
            shouldScroll = false,
            windowHeight = $(window).height(),
            windowWidth = $(window).width();
        
        //console.log('This clicked element: ');
        //console.log(this.$element);
        //console.log('BUTTON X: ' + buttonX);
        //console.log('BUTTON Y: ' + buttonY);
        //console.log('BUTTON Y OFFSET: ' + this.$element.offset().top);
        //console.log('SCROLL: ' + $(window).scrollTop());
        //console.log('BUTTON WIDTH: ' + buttonWidth);
        //console.log('POPUP WIDTH: ' + popupWidth);
        //console.log('POPUP HEIGHT: ' + popupHeight);

        //console.log('CALIBRATING');
        //console.log("window height: " + windowHeight);
        //console.log("window width: " + windowWidth);

        if (windowWidth > 350) {
            this.popupOffset = 10;
        }
        if ($thisFocus.hasClass('js-dialog-input') && windowWidth < 500) {
            popupLeft = this.popupOffset;
            popupTop = -10;
            shouldScroll = true;
            //console.log('GONNA JUMP');

        } else {
            if (buttonY < popupHeight + 20) {
                // console.log('popup goes below');
                var popupTop = buttonY + buttonHeight + 20,
                    bottomArrow = false;
            } else {
                //console.log('popup goes above');
                var popupTop = buttonY - popupHeight - 20,
                    bottomArrow = true;
                //console.log('BUTTON VERTICAL OFFSET: ' + buttonY);
                //console.log('POPUP HEIGHT: ' + popupHeight);
                //console.log('popup top position: ' + popupTop);
            }
            if ((buttonX + (buttonWidth / 2)) < popupWidth / 2) {
                //console.log('POPUP OFFSCREEN LEFT');
                var popupLeft = this.popupOffset,
                    overlap = -((buttonX + (buttonWidth / 2)) - popupWidth / 2) + this.popupOffset,
                    arrowSpot = (popupWidth / 2 - 15) - overlap;

            } else {
                if (windowWidth < (buttonX + buttonWidth / 2 + popupWidth / 2)) {
                    //console.log('popup offscreen right');
                    var popupLeft = windowWidth - popupWidth - this.popupOffset,
                        overlap = (buttonX + buttonWidth / 2 + popupLeft) - windowWidth,
                        arrowSpot = (buttonX + (buttonWidth / 2) - 15) + (popupLeft);
                } else {
                    // console.log('POPUP ONSCREEN HORIZONTAL');
                    //console.log('ButtonX: ' + buttonX);
                    // console.log('BUTTON WIDTH: ' + buttonWidth);
                    // console.log('POPUP WIDTH: ' + popupWidth);

                    var popupLeft = (buttonX + (buttonWidth / 2)) - popupWidth / 2,
                        arrowSpot = popupWidth / 2 - 15;
                }

            }
        }
        
        
            
        /*console.log('left: ' + popupLeft);
        console.log('top: ' + popupTop);
        console.log('window scroll: ' + windowScroll);
        console.log('overlap: ' + overlap);
        console.log('arrowSpot: ' + arrowSpot);*/
        //console.log('SET POSTION');
        this.setPosition(popupLeft, popupTop, arrowSpot, bottomArrow);
        if (shouldScroll) {
            $(window).scrollTop(0);
        }
        if (!this.isCalibrated) {
            //console.log('Adding scroll events');
            $(window).smartresize(function () {
                that.calibrate();
                //console.log('RESIZED');
            }, 'popup');
            $(window).smartscroll(function () {
                that.calibrate();
                var scroll = $(window).scrollTop();
               // console.log('scroll: ' + scroll);
            }, 'popup');
            this.isCalibrated = true;
        }
    };

    Plugin.prototype.addArrow = function (bottomArrow) {
        $('.js-dialog-arrow').remove();
        //console.log('ADD ARROW');
        var direction = '';
        if (bottomArrow) {
            direction = "-down";
            //console.log("ADD DOWN");
        } else {
            direction = "-up";
            //console.log("ADD UP");
        }
        var arrow = "<div class='dialog-bubble__arrow " + direction + " js-dialog-arrow'></div>";
        this.$popup.append(arrow);
    };

    Plugin.prototype.setPosition = function (x, y, arrowSpot, bottomArrow) {
        //console.log('Set position');
        this.addArrow(bottomArrow);
        var left = x + "px",
            top = y + "px";
        this.$popup.css({
            'left': left,
            'top' : top
        });
        $('.js-dialog-arrow').css({'left' : arrowSpot});
        //console.log('POSITION SET');
        //console.log("Left: " + left + " Top: " + top);
    };

    // Plugin wrapper
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                new Plugin(this, options));
            }
        });
    }


    // Self init
    $('body').on('call-popup', function (e) {
        var link = e.activeItem;
        //console.log(e);
        //console.log('BODY CLICK');
        //console.log(link);
        link.popupPosition();
    });

    //$(window).on('scroll', function () {
    //    var scroll = $(window).scrollTop();
    //    console.log('Scroll = ' + scroll);
    //});

    $('button[data-bind="click: Save"]').on('click', function () {
        //console.log('CLOSING THE POPUP');
        //$(window).off('scroll.popup');
        //$(window).off('resize.popup');
    });

})(jQuery, window, document);